import Vue from 'vue'
import Vuex from 'vuex'
import vuexPersistedstate from 'vuex-persistedstate'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    vuexPersistedstate({
      key: 'D2C',
      paths: [
        'userConfig',
        'sessionConfig',
        'lastProviderId',
        'token',
      ],
    })
  ],
  state,
  getters,
  mutations,
  actions,
})

export default store
